module.exports = __webpack_public_path__ + "img/飞机.85a539da.png";